import React, { useState } from 'react';
import { downloadExcel } from '../../services/adminService';
import './AdminExportPage.css';

const AdminExportPage = () => {
  const [exportType, setExportType] = useState('all'); // 'all', 'filtered'
  const [exporting, setExporting] = useState(false);

  const handleExport = async () => {
    setExporting(true);
    try {
      const params = {};
      if (exportType === 'filtered') {
        // 필터링된 데이터는 현재 필터 상태를 가져와야 함
        // 여기서는 예시로 빈 객체 사용
      }

      const blob = await downloadExcel(params);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `회원정보_${new Date().toISOString().split('T')[0]}.xlsx`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
      alert('Excel 파일 다운로드가 완료되었습니다.');
    } catch (error) {
      alert('Excel 다운로드에 실패했습니다.');
      console.error('Excel 다운로드 실패:', error);
    } finally {
      setExporting(false);
    }
  };

  return (
    <div className="admin-export-page">
      <h1>Excel 다운로드</h1>

      <div className="export-card">
        <h2>데이터 범위 선택</h2>
        <div className="radio-group">
          <label>
            <input
              type="radio"
              value="all"
              checked={exportType === 'all'}
              onChange={(e) => setExportType(e.target.value)}
            />
            <span>모든 회원정보</span>
          </label>
          <label>
            <input
              type="radio"
              value="filtered"
              checked={exportType === 'filtered'}
              onChange={(e) => setExportType(e.target.value)}
            />
            <span>검색/필터링된 데이터</span>
          </label>
        </div>

        <div className="export-info">
          <h3>포함 컬럼</h3>
          <ul>
            <li>회원정보: 성함, 회사명, 이메일</li>
            <li>설문지: 각 항목의 예/아니오 답변</li>
          </ul>
        </div>

        <button
          onClick={handleExport}
          className="export-btn"
          disabled={exporting}
        >
          {exporting ? '다운로드 중...' : 'Excel 다운로드'}
        </button>
      </div>
    </div>
  );
};

export default AdminExportPage;

